import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  languageModelContainer: {
    paddingTop: 34,
  },
  languageModelHeader: {
    marginHorizontal: 0,
  },
  languageModelSubTitle: {
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    marginTop: 17,
    lineHeight: 31.2,
    marginBottom: 28.5,
  },

  radioContainer: (lastChild, theme) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12.5,
    borderBottomWidth: lastChild ? 1 : 0,
    borderBottomColor: theme.colors.divider,
  }),
  iconTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  radioIcon: {
    marginRight: 16,
  },
  radioText: {
    fontSize: 18.7,
    lineHeight: 25,
  },
  languageModelBtn: {
    marginTop: 45,
    marginBottom: 24,
  },
});
